<div class="content">
    <button (click)="downloadFile()">
        <i class="fa fa-download"></i>
        Download Sample
      </button>
    <ag-grid-angular 
    class="ag-theme-alpine" 
    style="height: 53vh; width: 83vw; margin-left: 6px;" 
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef" 
    [gridOptions]="gridOptions"
    [rowData]="rowData"
    (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div>